import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    if (typeof window['loadFile'] === 'function') {
      // Call the function with parameters if needed
      window['loadFile']();
    } else {
      console.error('myFunction is not defined in the global scope.');
    }
  }

}
